import { createContext } from "react";

export interface ChatWidgetContextType {
  isExpanded: boolean;
  pendingMessage: string | null;
  expand: () => void;
  collapse: () => void;
  toggle: () => void;
  submitMessage: (text: string) => void;
  clearPendingMessage: () => void;
}

export const ChatWidgetContext = createContext<ChatWidgetContextType | undefined>(
  undefined
);
